import { Panel } from "../../components/panels/Panel";
import { DateRangePickerComponent } from "../../components/others/DateRangePickerComponent";
import { ActionButton } from "../../components/buttons/ActionButton";
import {
  ClockIcon,
} from "@heroicons/react/20/solid";
import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import { LisiDashboardOF } from "./lisi-components/LisiDashboardOF";
import { LisiDashboardGlobal } from "./lisi-components/LisiDashboardGlobal";


export const LISIDashboard = () => {

  /* Active view */
  const [selectedView, setSelectedView] = useState('global');

  /* Dates management */
  const dateRangePickerRef = useRef(null);
  const now = new Date();
  const defaultStart = new Date(now);
  defaultStart.setHours(6, 0, 0, 0);
  const defaultEnd = new Date(now);
  defaultEnd.setHours(18, 0, 0, 0);
  const yesterdayStart = new Date(now);
  const yesterdayStop = new Date(now);
  yesterdayStart.setDate(yesterdayStart.getDate() - 1);
  yesterdayStart.setHours(0, 0, 0, 0);
  yesterdayStop.setDate(yesterdayStop.getDate() - 1);
  yesterdayStop.setHours(23, 59, 59, 999);
  const thisWeekStart = new Date(now);
  const thisWeekStop = new Date(now);
  const currentDay = thisWeekStart.getDay();
  const mondayOffset = currentDay === 0 ? -6 : 1 - currentDay;
  thisWeekStart.setDate(thisWeekStart.getDate() + mondayOffset);
  thisWeekStart.setHours(0, 0, 0, 0);
  thisWeekStop.setDate(thisWeekStart.getDate() + 6);
  thisWeekStop.setHours(23, 59, 59, 999);

  const dateRangeStorageKey = 'dashboard-date-range';

  const getInitialSelectedRange = () => {
    if (!dateRangeStorageKey) {
      return { start: defaultStart, end: defaultEnd };
    }

    try {
      const storedRange = localStorage.getItem(dateRangeStorageKey);

      if (storedRange) {
        const parsedRange = JSON.parse(storedRange);

        if (parsedRange?.start && parsedRange?.end) {
          return {
            start: new Date(parsedRange.start),
            end: new Date(parsedRange.end),
          };
        }
      }
    } catch {
      localStorage.removeItem(dateRangeStorageKey);
    }

    return { start: defaultStart, end: defaultEnd };
  };

  const [selectedRange, setSelectedRange] = useState(getInitialSelectedRange);

  return (
    <Panel category='main' title='DASHBOARD'>
      <div className="h-full flex flex-col gap-4">
        <div className="h-16 flex gap-4">
          <Panel noHeader category="secondary" rounded height="h-16" width="w-fit" className="shrink-0">
            <div className="flex gap-4 items-center h-full">
              <ActionButton text="Vue globale" onClick={() => setSelectedView('global')} color={selectedView === 'global' ? 'secondary' : 'transparent'}/>
              <ActionButton text="Vue par OF" onClick={() => setSelectedView('of')} color={selectedView === 'of' ? 'secondary' : 'transparent'}/>
            </div>
          </Panel>

          <Panel noHeader category="secondary" rounded height="h-16" width="flex-1" className="min-w-0">
            <div className="flex gap-4 items-center h-full">
              <ActionButton text="Aujourd'hui" size="sm" onClick={() => dateRangePickerRef.current?.selectAndValidate(defaultStart, defaultEnd)}/>
              <ActionButton text="Hier" size="sm" onClick={() => dateRangePickerRef.current?.selectAndValidate(yesterdayStart, yesterdayStop)}/>
              <ActionButton text="Cette semaine" size="sm" onClick={() => dateRangePickerRef.current?.selectAndValidate(thisWeekStart, thisWeekStop)}/>

              <DateRangePickerComponent
                ref={dateRangePickerRef}
                trigger={({ isCalendarOpen, setIsCalendarOpen }) => (
                  <ActionButton text="Sélectionner période" color="secondary" Icon={ClockIcon} size="sm" onClick={() => setIsCalendarOpen(!isCalendarOpen)} />
                )}
                defaultStart={selectedRange.start} defaultEnd={selectedRange.end}
                callback={(start, end) => setSelectedRange({ start, end })}
                cancelText="Annuler" validateText="Charger"
                alwaysShowValidateButton={true}
                storageKey={dateRangeStorageKey}
              />
            </div>
          </Panel>
        </div>

        {
          selectedView === 'global' ?
            <LisiDashboardGlobal selectedRange={selectedRange} />
          : selectedView === 'of' ?
            <LisiDashboardOF selectedRange={selectedRange} />
          : null
        }


      </div>
    </Panel>
  );
};